const SET_PAGINATION = (state, headers) => {
  // заполняем массив номерами страниц от 1 до последней страницы
  state.pagination.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
}

const SET_PER_PAGE = (state, perPage) => {
  state.pagination.perPage = perPage
}

const SET_CURRENT_PAGE = (state, pageNum) => {
  state.pagination.currentPage = pageNum
}

export {
  SET_PER_PAGE,
  SET_PAGINATION,
  SET_CURRENT_PAGE
}
